import { useState } from "react";
import { NavLink } from "react-router-dom";

import { NAV_ITEMS } from "../routes";
import { Button } from "../components/Button";
import { cx } from "../lib/cx";

interface TopNavProps {
  onOpenMobileNav: () => void;
}

export function TopNav({ onOpenMobileNav }: TopNavProps) {
  return (
    <header className="top-nav-shell">
      <div className="top-nav">
        <NavLink to="/investment-case" className="brand-lockup" aria-label="400 Norwood investment case">
          <span className="brand-mark" />
          <div>
            <div className="brand-title">400 Norwood</div>
            <div className="brand-subtitle">Investor Site</div>
          </div>
        </NavLink>

        <nav className="desktop-nav" aria-label="Primary">
          {NAV_ITEMS.map((item) => (
            <NavLink key={item.path} to={item.path} className={({ isActive }) => cx("nav-link", isActive && "is-active")} end>
              {item.label}
            </NavLink>
          ))}
        </nav>

        <div className="top-nav-actions">
          <NavLink to="/memo" className="link-button link-button-primary desktop-only">Read Memo</NavLink>
          <Button variant="ghost" className="mobile-nav-button" onClick={onOpenMobileNav} aria-label="Open navigation">
            Menu
          </Button>
        </div>
      </div>
    </header>
  );
}
